// Dependencies
import styled, { css } from 'styled-components';

// Types
import { variantSearchBar } from './types';

interface ContainerProps {
  variant: variantSearchBar;
}

export const Container = styled.div<ContainerProps>`
  position: relative;
  display: flex;

  ${({ variant }) =>
    ({
      big: css`
        max-width: 189.6rem;
        width: 100%;
        box-shadow: ${({ theme }) => theme.shadows.toast};
      `,
      small: css`
        max-width: 189.6rem;
        width: 21rem;
        box-shadow: ${({ theme }) => theme.shadows.toast};
      `,
      form: css`
        max-width: 189.6rem;
        box-shadow: none;
        border: 0.1rem solid ${({ theme }) => theme.colors.black};
      `,
      campaign: css`
        border: 0.1rem solid ${({ theme }) => theme.colors.black};
      `,
    })[variant]}
  height: ${({ variant }) => (variant === 'campaign' ? '4rem' : '4.5rem')};
  border-radius: 0.5rem;
  background-color: ${({ theme }) => theme.colors.white};
  align-items: center;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    ${({ variant }) => (variant === 'campaign' ? 'none' : '53.8rem')};
  }
`;

export const Input = styled.input`
  flex: 1;
  height: 100%;
  border-radius: 0.5rem;
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.black};
  border-style: none;
  font-family: 'Poppins', sans-serif;
  font-size: ${({ theme }) => theme.fontSize.M};
  padding-left: 5.2rem;
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  width: 100%;

  &::placeholder {
    color: ${({ theme }) => theme.colors.greySoftLight};
  }

  &:focus {
    outline: 0.08rem solid ${({ theme }) => theme.colors.black};
  }

  &:focus::placeholder {
    color: transparent;
  }

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    font-size: ${({ theme }) => theme.fontSize.M};
  }
`;

export const Icon = styled.img`
  position: absolute;
  margin-left: 2rem;
  width: 1.6rem;
  height: 1.6rem;
`;
